import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "@trainrr/api/router";

export const trpc = createTRPCReact<AppRouter>();
